import {useState} from "react";

import "./FileFormFiled.css"
import PrimaryLabel from "../primaryLabel/PrimaryLabel";
import PrimaryInput from "../primaryInput/PrimaryInput";
import {ErrorMessage, ErrorMessageStyle} from "../errorMessage/ErrorMessage";

export default function FileFormField(props) {
    const title = props.title;
    const id = props.id;
    const onChange = props.onChange;
    const required = props.required;
    const errorMessage = props.errorMessage;
    const [fileName, setFileName] = useState(props.fileName ?? props.titleFile);

    function onChangeFile(e) {
        let files = e.target.files;
        if (files.length > 0) {
          const file = files[0];
          setFileName(file.name);
          onChange({id: id, file: file});
        }
    }
    return (
        <div className="mb-5 w-full">
            <PrimaryLabel>{title}{required ? <span className={"text-red-500 font-medium"}>*</span> : <></>}</PrimaryLabel>
            <div className="flex col-flex justify-center gap-8"> 
	              <PrimaryInput
	                  onChange={onChangeFile}
	                  type="file"
	                  placeholder="Type client code"
	                  accept="image/*"
	                  extraClassName={`image-form-field-file-input ${errorMessage ? "outline-none ring-2 ring-red-500" : ""}`}
	              />
	              {fileName && <p className="whitespace-nowrap overflow-hidden text-ellipsis w-4/6 shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight">{fileName}</p>}
	            </div>
              {errorMessage && (
                  <div className="mt-2">
                      <ErrorMessage style={ErrorMessageStyle.SMALL}>{errorMessage}</ErrorMessage>
                  </div>
              )}
	        </div>
	    );
	}
